export default {
    SCREEN: 'screen',
    IS_ADVANCED_DIAGNOSTIC: 'isAdvancedDiagnostic',
    SOURCE: 'source',
    LANGUAGE: 'l',
    MODAL: 'modal',
    DEVICE_TYPE: 'deviceType',
    TNC_PAGE_TYPE: 'type',
};
